import * as z from "zod";

export const getPayPalAuthUrl = {
  name: "getPayPalAuthUrl" as const,
  /** popup: sign the OAuth state so the callback self-closes the popup window
   * instead of redirecting the top frame. */
  input: z.object({ popup: z.boolean().optional() }),
  output: z.object({ authorizationUrl: z.string() }),
};
